export default "__VITE_ASSET__DuRN0Y9z__"